import { AutoSizer, List } from 'react-virtualized';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import MentionIcon from './images/mention.svg?react';
import styles from './index.module.scss';

const MembersList = ({
  title,
  count,
  members,
  mentionUserIds,
}: {
  title: string;
  count: number;
  members: ChatGroupMember[];
  mentionUserIds: Set<string>;
  loading?: boolean;
}) => {
  const memberRowRenderer = ({ index, style }: any) => {
    const member = members[index];
    return (
      <div className={styles.memberItem} key={member.user_id} style={style}>
        <MyAvatar src={member.avatar} info={member} />
        {mentionUserIds.has(member.user_id) && (
          <MentionIcon className={styles.mentionIcon}></MentionIcon>
        )}
        <div className={styles.info}>
          <div className={styles.name}>{member.name}</div>
          {member?.username && (
            <div className={styles.shortName}>@{member?.username}</div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.list}>
      <div className={styles.title}>
        <span>{count}</span>
        <span>{title}</span>
      </div>
      <div className={styles.vList}>
        <AutoSizer>
          {({ height, width }) => (
            <List
              className="scrollbar_hover"
              width={width}
              height={height}
              rowCount={members.length}
              rowHeight={36}
              rowRenderer={memberRowRenderer}
              noRowsRenderer={() => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
              scrollToIndex={0}
            />
          )}
        </AutoSizer>
      </div>
    </div>
  );
};

export default memo(MembersList);
